import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getSMDSearchlist } from "../Actions/SMDlistingAPI";

const searchData = {
  companyname: '', pagenumber: 1, pagesize: 10
}

export const postSMDData = (postItem) => {
  let url = `${API.SMDPostAPI}`;
  return dispatch => {
    axios.post(url, postItem)
      .then((response) => {
        if (response.data) {
          toast.success('Added Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getSMDSearchlist(searchData));
        }
        dispatch({
          type: "SMDPostSuccessfull",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "SMDPostSuccessFailure",
          error: "ERROR"
        })
      })
  }
}
export const updateSMDData = (postItem) => {
  let url = `${API.SMDPostAPI}`;
  return dispatch => {
    axios.put(url, postItem)
      .then((response) => {
        // dispatch({type:'SMDUpdate',data:true})
        dispatch({
          type: "SMDupdateSuccess",
          data: response.data,
        })
        toast.success('SDoC Data Updated Successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(getSMDSearchlist(searchData));
      })
      .catch((error) => {
        dispatch({
          type: "SMDupdateFailure",
          error: "ERROR"
        })
      })
  }
}
export const postSMDAttachment = (postItem) => {
  const data = new FormData()
  data.append('file', postItem)
  let url = `${API.AttachmentAPI}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        console.log(response.data)
        dispatch({

          type: "SMDAttchmentUploadSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "SMDAttchmentUploadFailure",
          error: "ERROR"
        })
      })
  }
}
